import React from "react";
import { Box, Breadcrumbs, Link, Typography } from "@material-ui/core";
import { pageBreadcrumbsProps } from "./PageBreadcrumbs.d";
import useBreadcrumbsStyles from "./PageBreadcrumbsStyles";
import { Home } from "@mui/icons-material";

const PageBreadcrumbs: React.FC<pageBreadcrumbsProps> = ({ nodes }) => {
	const classes = useBreadcrumbsStyles();
	return (
		<Box className={classes.container}>
			<Breadcrumbs separator="›" aria-label="breadcrumb">
				<Link href="/" color="primary" underline="always">
					<Home fontSize="large" />
				</Link>
				{nodes &&
					nodes.map((node) => {
						return node.path ? (
							<Link key={node.name} href={node.path} underline="always" className={classes.pageTitle}>
								{node.name}
							</Link>
						) : (
							<Typography key={node.name} noWrap variant="h3" className={classes.pageTitle}>
								{node.name}
							</Typography>
						);
					})}
			</Breadcrumbs>
		</Box>
	);
};
export default PageBreadcrumbs;
